import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

// ── Icônes SVG ─────────────────────────────────────────────────
const IcUsers     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcBriefcase = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>;
const IcCalendar  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcMoney     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcAlert     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const IcCheck     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcX         = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcBan       = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>;
const IcRefresh   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>;
const IcSearch    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8B5E3C" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>;
const IcGrid      = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcPeople    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcBookmark  = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>;
const IcCard      = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcFlag      = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>;
const IcUser      = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;

// ── Labels ──────────────────────────────────────────────────────
const ROLE_LABELS = {
  client:       { label: "Client",        color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  chauffeur:    { label: "Chauffeur",     color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
  bailleur:     { label: "Bailleur",      color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  restaurateur: { label: "Restaurateur",  color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
  artisan:      { label: "Artisan",       color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  guide:        { label: "Guide",         color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  loueur:       { label: "Loueur",        color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
  loisir:       { label: "Loisirs",       color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
};

const STATUT_USER = {
  actif:       { label: "Actif",       color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  suspendu:    { label: "Suspendu",    color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
  en_attente:  { label: "En attente",  color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  valide:      { label: "Validé",      color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
};

const STATUT_RESA = {
  confirmee:  { label: "Confirmée",  color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  en_attente: { label: "En attente", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  annulee:    { label: "Annulée",    color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
};

const STATUT_PAY = {
  recu:       { label: "Reçu",       color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  en_attente: { label: "En attente", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  rembourse:  { label: "Remboursé",  color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
};

const STATUT_SIGNAL = {
  ouvert:   { label: "Ouvert",   color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
  en_cours: { label: "En cours", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  resolu:   { label: "Résolu",   color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
};

const PRIORITE = {
  haute:   { label: "Haute",   color: "#C4441A" },
  moyenne: { label: "Moyenne", color: "#C4841A" },
  basse:   { label: "Basse",   color: "#3D6B2E" },
};

const TYPE_SIGNAL = {
  comportement: "Comportement",
  fraude:       "Fraude",
  contenu:      "Contenu",
  paiement:     "Paiement",
};

const ONGLETS = [
  { id: "dashboard",    label: "Vue générale",  Icon: IcGrid },
  { id: "utilisateurs", label: "Utilisateurs",  Icon: IcPeople },
  { id: "reservations", label: "Réservations",  Icon: IcBookmark },
  { id: "paiements",    label: "Paiements",     Icon: IcCard },
  { id: "signalements", label: "Signalements",  Icon: IcFlag },
];

const API = "https://senutour.com/api";
const headers = () => ({ "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` });

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [onglet, setOnglet]             = useState("dashboard");
  const [filtreRole, setFiltreRole]     = useState("tous");
  const [filtreStatut, setFiltreStatut] = useState("tous");
  const [recherche, setRecherche]       = useState("");
  const [loading, setLoading]           = useState(true);
  const [adminNom, setAdminNom]         = useState("");

  const [stats, setStats]               = useState({ total_utilisateurs: 0, total_prestataires: 0, reservations_mois: 0, revenus_mois: 0 });
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [prestataires, setPrestataires] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [paiements, setPaiements]       = useState([]);
  const [signalements, setSignalements] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setAdminNom(user.prenom ? `${user.prenom} ${user.nom}` : "Administrateur SenuTour");

    const load = async () => {
      setLoading(true);
      try {
        const [statsRes, usersRes, presRes, resaRes, payRes, signalRes] = await Promise.allSettled([
          fetch(`${API}/admin/stats`,         { headers: headers() }),
          fetch(`${API}/admin/utilisateurs`,  { headers: headers() }),
          fetch(`${API}/admin/prestataires`,  { headers: headers() }),
          fetch(`${API}/admin/reservations`,  { headers: headers() }),
          fetch(`${API}/admin/paiements`,     { headers: headers() }),
          fetch(`${API}/admin/signalements`,  { headers: headers() }),
        ]);

        if (statsRes.status === "fulfilled" && statsRes.value.ok) {
          const d = await statsRes.value.json(); setStats(d);
        }
        if (usersRes.status === "fulfilled" && usersRes.value.ok) {
          const d = await usersRes.value.json(); setUtilisateurs(d);
        }
        if (presRes.status === "fulfilled" && presRes.value.ok) {
          const d = await presRes.value.json(); setPrestataires(d);
        }
        if (resaRes.status === "fulfilled" && resaRes.value.ok) {
          const d = await resaRes.value.json(); setReservations(d);
        }
        if (payRes.status === "fulfilled" && payRes.value.ok) {
          const d = await payRes.value.json(); setPaiements(d);
        }
        if (signalRes.status === "fulfilled" && signalRes.value.ok) {
          const d = await signalRes.value.json(); setSignalements(d);
        }
      } catch (err) {
        console.error("Erreur chargement admin :", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // ── Actions backend ─────────────────────────────────────────
  const validerPrestataire = async (id) => {
    await fetch(`${API}/admin/prestataires/${id}/valider`, { method: "PATCH", headers: headers() });
    setPrestataires(p => p.map(x => x.id === id ? { ...x, statut: "valide" } : x));
  };

  const refuserPrestataire = async (id) => {
    await fetch(`${API}/admin/prestataires/${id}/refuser`, { method: "PATCH", headers: headers() });
    setPrestataires(p => p.filter(x => x.id !== id));
  };

  const toggleSuspension = async (id, estSuspendu, type) => {
    const action = estSuspendu ? "reactiver" : "suspendre";
    await fetch(`${API}/admin/${type}/${id}/${action}`, { method: "PATCH", headers: headers() });
    const setter = type === "utilisateurs" ? setUtilisateurs : setPrestataires;
    setter(prev => prev.map(x => x.id === id ? { ...x, statut: estSuspendu ? "actif" : "suspendu" } : x));
  };

  const resoudreSignalement = async (id) => {
    await fetch(`${API}/admin/signalements/${id}/resoudre`, { method: "PATCH", headers: headers() });
    setSignalements(s => s.map(x => x.id === id ? { ...x, statut: "resolu" } : x));
  };

  // ── Confirmer / Annuler une réservation ────────────
  const confirmerReservation = async (id) => {
    await fetch(`${API}/admin/reservations/${id}/confirmer`, { method: "PATCH", headers: headers() });
    setReservations(r => r.map(x => x.id === id ? { ...x, statut: "confirmee" } : x));
  };

  const annulerReservation = async (id) => {
    await fetch(`${API}/admin/reservations/${id}/annuler`, { method: "PATCH", headers: headers() });
    setReservations(r => r.map(x => x.id === id ? { ...x, statut: "annulee" } : x));
  };

  // ── Filtres ──────────────────────────────────────────────────
  const signalements_ouverts = signalements.filter(s => s.statut === "ouvert").length;
  const prestataires_attente = prestataires.filter(p => p.statut === "en_attente").length;
  const reservations_attente = reservations.filter(r => r.statut === "en_attente").length;

  const filtrer = (liste) => liste.filter(u => {
    const matchRole   = filtreRole   === "tous" || u.role   === filtreRole;
    const matchStatut = filtreStatut === "tous" || u.statut === filtreStatut;
    const matchSearch = `${u.prenom || ""} ${u.nom || ""} ${u.email || ""}`.toLowerCase().includes(recherche.toLowerCase());
    return matchRole && matchStatut && matchSearch;
  });

  // ── Composants ───────────────────────────────────────────────
  const BadgeStatut = ({ statut, map }) => (
    <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: map[statut]?.bg || "#eee", color: map[statut]?.color || "#666" }}>
      {map[statut]?.label || statut}
    </span>
  );

  const Vide = ({ texte }) => (
    <div style={{ padding: "48px 24px", textAlign: "center", color: "#B8A898", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14 }}>
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#C4441A" strokeWidth="1.5" strokeLinecap="round" style={{ marginBottom: 12, opacity: 0.4 }}>
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <p style={{ margin: 0 }}>{texte}</p>
    </div>
  );

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF5EC", fontFamily: "'Space Grotesk',sans-serif", color: "#7A5A3A", fontSize: 15 }}>
      Chargement du tableau de bord…
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{ fontFamily: "'Space Grotesk',sans-serif", background: "#FAF5EC", minHeight: "100vh", color: "#1C1008" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .onglet-btn { transition: all .2s; cursor: pointer; border: none; background: none; }
          .onglet-btn:hover { color: #C4441A !important; }
          .card-hover { transition: box-shadow .2s, transform .2s; }
          .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          .btn-primary { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
          .btn-primary:hover { background: #A03614; }
          .btn-success { background: #3D6B2E; transition: background .2s; border: none; cursor: pointer; }
          .btn-success:hover { background: #2D5220; }
          .row-hover:hover { background: rgba(196,68,26,0.02) !important; }
          @media (max-width: 767px) { .stats-grid { grid-template-columns: 1fr 1fr !important; } }
        `}</style>

        {/* ── HEADER ── */}
        <div style={{ background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)", padding: "36px 5%", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle,rgba(196,68,26,.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />
          <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", border: "3px solid rgba(255,255,255,0.2)", flexShrink: 0, overflow: "hidden" }}>
                  {localStorage.getItem("sunutour_photo")
                    ? <img src={localStorage.getItem("sunutour_photo")} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="profil" />
                    : <IcUser />
                  }
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>Dashboard Admin · JOJ 2026</div>
                  <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", margin: 0 }}>{adminNom}</h1>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>Gestion globale de la plateforme SenuTour</div>
                </div>
              </div>
              <button onClick={() => navigate("/profil")}
                style={{ background: "rgba(255,255,255,0.10)", border: "1.5px solid rgba(255,255,255,0.2)", borderRadius: 10, padding: "10px 18px", color: "white", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                <IcUser /> Mon profil
              </button>
            </div>
          </div>
        </div>

        {/* ── ONGLETS ── */}
        <div style={{ background: "white", borderBottom: "1.5px solid #E8DCC8", padding: "0 5%", overflowX: "auto" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", gap: 4, minWidth: "max-content" }}>
            {ONGLETS.map(o => (
              <button key={o.id} className="onglet-btn"
                onClick={() => { setOnglet(o.id); setFiltreRole("tous"); setFiltreStatut("tous"); setRecherche(""); }}
                style={{ padding: "16px 18px", fontSize: 13, fontWeight: 600, color: onglet === o.id ? "#C4441A" : "#7A5A3A", borderBottom: onglet === o.id ? "2px solid #C4441A" : "2px solid transparent", marginBottom: -1, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                <o.Icon /> {o.label}
                {o.id === "signalements" && signalements_ouverts > 0 && (
                  <span style={{ background: "#C4441A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{signalements_ouverts}</span>
                )}
                {o.id === "utilisateurs" && prestataires_attente > 0 && (
                  <span style={{ background: "#C4841A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{prestataires_attente}</span>
                )}
                {o.id === "reservations" && reservations_attente > 0 && (
                  <span style={{ background: "#C4841A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{reservations_attente}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "36px 5% 60px" }}>

          {/* ══ VUE GÉNÉRALE ══ */}
          {onglet === "dashboard" && (
            <>
              <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 32 }}>
                {[
                  { label: "Utilisateurs",        value: stats.total_utilisateurs.toLocaleString(), suffix: "",    Icon: IcUsers,     color: "#C4441A" },
                  { label: "Prestataires",         value: stats.total_prestataires,                  suffix: "",    Icon: IcBriefcase, color: "#3D6B2E" },
                  { label: "Réservations ce mois", value: stats.reservations_mois,                   suffix: "",    Icon: IcCalendar,  color: "#C4841A" },
                  { label: "Revenus ce mois",      value: Number(stats.revenus_mois || 0).toLocaleString(), suffix: " F", Icon: IcMoney, color: "#3D6B2E" },
                ].map((s, i) => (
                  <div key={i} className="card-hover" style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                    <div style={{ color: s.color, marginBottom: 10 }}><s.Icon /></div>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, color: s.color }}>
                      {s.value}<span style={{ fontSize: 13, fontWeight: 600 }}>{s.suffix}</span>
                    </div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 4, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
                {/* Prestataires en attente */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Prestataires en attente</h3>
                    <button onClick={() => setOnglet("utilisateurs")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {prestataires.filter(p => p.statut === "en_attente").length === 0
                    ? <Vide texte="Aucun prestataire en attente" />
                    : prestataires.filter(p => p.statut === "en_attente").map((p, i, arr) => (
                      <div key={p.id} style={{ padding: "14px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none", display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 800, color: "white", flexShrink: 0 }}>
                          {(p.prenom?.[0] || "")}{(p.nom?.[0] || "")}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{p.prenom} {p.nom}</div>
                          <div style={{ fontSize: 11, color: "#7A5A3A" }}>{ROLE_LABELS[p.role]?.label} · {p.ville}</div>
                        </div>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button className="btn-success" onClick={() => validerPrestataire(p.id)} style={{ color: "white", borderRadius: 8, padding: "6px 10px", display: "flex", alignItems: "center" }}><IcCheck /></button>
                          <button className="btn-primary" onClick={() => refuserPrestataire(p.id)} style={{ color: "white", borderRadius: 8, padding: "6px 10px", display: "flex", alignItems: "center" }}><IcX /></button>
                        </div>
                      </div>
                    ))
                  }
                </div>

                {/* Signalements ouverts */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Signalements ouverts</h3>
                    <button onClick={() => setOnglet("signalements")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {signalements.filter(s => s.statut === "ouvert").length === 0
                    ? <Vide texte="Aucun signalement ouvert" />
                    : signalements.filter(s => s.statut === "ouvert").map((s, i, arr) => (
                      <div key={s.id} style={{ padding: "14px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{s.auteur} → {s.cible}</div>
                          <span style={{ fontSize: 11, fontWeight: 700, color: PRIORITE[s.priorite]?.color }}>● {PRIORITE[s.priorite]?.label}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#7A5A3A" }}>{TYPE_SIGNAL[s.type]} · {s.date}</div>
                      </div>
                    ))
                  }
                </div>
              </div>

              {/* Dernières réservations */}
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Dernières réservations</h3>
                  <button onClick={() => setOnglet("reservations")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                </div>
                {reservations.length === 0 ? <Vide texte="Aucune réservation pour le moment" /> : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#FAF5EC" }}>
                        {["Client", "Service", "Date", "Montant", "Statut"].map(h => (
                          <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {reservations.slice(0, 4).map((r, i) => (
                        <tr key={r.id} className="row-hover" style={{ borderBottom: i < Math.min(3, reservations.length - 1) ? "1px solid #F2E4C8" : "none" }}>
                          <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.client}</td>
                          <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{r.service}</td>
                          <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.date}</td>
                          <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 14, fontWeight: 700, color: "#C4441A" }}>{Number(r.montant || 0).toLocaleString()} F</td>
                          <td style={{ padding: "14px 20px" }}><BadgeStatut statut={r.statut} map={STATUT_RESA} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          )}

          {/* ══ UTILISATEURS ══ */}
          {onglet === "utilisateurs" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Utilisateurs & Prestataires</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{utilisateurs.length + prestataires.length} comptes enregistrés</p>
              </div>

              <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
                <div style={{ position: "relative" }}>
                  <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }}><IcSearch /></span>
                  <input placeholder="Rechercher..." value={recherche} onChange={e => setRecherche(e.target.value)}
                    style={{ padding: "9px 14px 9px 36px", border: "1.5px solid #E8DCC8", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#1C1008", background: "white", outline: "none", minWidth: 220 }} />
                </div>
                <select value={filtreRole} onChange={e => setFiltreRole(e.target.value)}
                  style={{ padding: "9px 14px", border: "1.5px solid #E8DCC8", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#1C1008", background: "white", cursor: "pointer", outline: "none" }}>
                  <option value="tous">Tous les rôles</option>
                  {Object.entries(ROLE_LABELS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
                <select value={filtreStatut} onChange={e => setFiltreStatut(e.target.value)}
                  style={{ padding: "9px 14px", border: "1.5px solid #E8DCC8", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#1C1008", background: "white", cursor: "pointer", outline: "none" }}>
                  <option value="tous">Tous les statuts</option>
                  <option value="actif">Actif</option>
                  <option value="suspendu">Suspendu</option>
                  <option value="en_attente">En attente</option>
                  <option value="valide">Validé</option>
                </select>
              </div>

              {filtrer(prestataires).filter(p => p.statut === "en_attente").length > 0 && (
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 800, color: "#1C1008", marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
                    <IcAlert /> En attente de validation
                  </h3>
                  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    {filtrer(prestataires).filter(p => p.statut === "en_attente").map(p => (
                      <div key={p.id} style={{ background: "white", borderRadius: 12, border: "1.5px solid rgba(196,132,26,0.30)", padding: "18px 24px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                        <div style={{ width: 44, height: 44, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 800, color: "white", flexShrink: 0 }}>
                          {(p.prenom?.[0] || "")}{(p.nom?.[0] || "")}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 14, fontWeight: 700, color: "#1C1008" }}>{p.prenom} {p.nom}</div>
                          <div style={{ fontSize: 12, color: "#7A5A3A" }}>{p.email} · {p.ville}</div>
                          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: ROLE_LABELS[p.role]?.bg, color: ROLE_LABELS[p.role]?.color, display: "inline-block", marginTop: 4 }}>
                            {ROLE_LABELS[p.role]?.label}
                          </span>
                        </div>
                        <div style={{ fontSize: 12, color: "#7A5A3A" }}>Inscrit le {p.date_inscription}</div>
                        <div style={{ display: "flex", gap: 8 }}>
                          <button className="btn-success" onClick={() => validerPrestataire(p.id)} style={{ color: "white", borderRadius: 8, padding: "8px 16px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}><IcCheck /> Valider</button>
                          <button className="btn-primary" onClick={() => refuserPrestataire(p.id)} style={{ color: "white", borderRadius: 8, padding: "8px 16px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}><IcX /> Refuser</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 800, color: "#1C1008", marginBottom: 14 }}>Prestataires</h3>
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden", marginBottom: 24 }}>
                {filtrer(prestataires).length === 0 ? <Vide texte="Aucun prestataire" /> : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#FAF5EC" }}>
                        {["Nom", "Rôle", "Ville", "Inscription", "Statut", "Actions"].map(h => (
                          <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filtrer(prestataires).map((p, i, arr) => (
                        <tr key={p.id} className="row-hover" style={{ borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                          <td style={{ padding: "14px 20px" }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{p.prenom} {p.nom}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A" }}>{p.email}</div>
                          </td>
                          <td style={{ padding: "14px 20px" }}>
                            <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: ROLE_LABELS[p.role]?.bg, color: ROLE_LABELS[p.role]?.color }}>{ROLE_LABELS[p.role]?.label || p.role}</span>
                          </td>
                          <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{p.ville}</td>
                          <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{p.date_inscription}</td>
                          <td style={{ padding: "14px 20px" }}><BadgeStatut statut={p.statut} map={STATUT_USER} /></td>
                          <td style={{ padding: "14px 20px" }}>
                            <button
                              onClick={() => toggleSuspension(p.id, p.statut === "suspendu", "prestataires")}
                              className={p.statut === "suspendu" ? "btn-success" : "btn-primary"}
                              style={{ color: "white", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 5 }}>
                              {p.statut === "suspendu" ? <><IcRefresh /> Réactiver</> : <><IcBan /> Suspendre</>}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 800, color: "#1C1008", marginBottom: 14 }}>Clients</h3>
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {filtrer(utilisateurs).length === 0 ? <Vide texte="Aucun client" /> : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#FAF5EC" }}>
                        {["Nom", "Email", "Ville", "Inscription", "Statut", "Actions"].map(h => (
                          <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filtrer(utilisateurs).map((u, i, arr) => (
                        <tr key={u.id} className="row-hover" style={{ borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                          <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{u.prenom} {u.nom}</td>
                          <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{u.email}</td>
                          <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{u.ville}</td>
                          <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{u.date_inscription}</td>
                          <td style={{ padding: "14px 20px" }}><BadgeStatut statut={u.statut} map={STATUT_USER} /></td>
                          <td style={{ padding: "14px 20px" }}>
                            <button
                              onClick={() => toggleSuspension(u.id, u.statut === "suspendu", "utilisateurs")}
                              className={u.statut === "suspendu" ? "btn-success" : "btn-primary"}
                              style={{ color: "white", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 5 }}>
                              {u.statut === "suspendu" ? <><IcRefresh /> Réactiver</> : <><IcBan /> Suspendre</>}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          )}

          {/* ══ RÉSERVATIONS ══ */}
          {onglet === "reservations" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Toutes les réservations</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>
                  {reservations.length} réservation{reservations.length !== 1 ? "s" : ""}
                  {reservations_attente > 0 && <span style={{ color: "#C4841A", fontWeight: 700 }}> · {reservations_attente} en attente de confirmation</span>}
                </p>
              </div>

              <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
                {["tous", "en_attente", "confirmee", "annulee"].map(s => (
                  <button key={s} onClick={() => setFiltreStatut(s)}
                    style={{ padding: "7px 16px", borderRadius: 20, border: `1.5px solid ${filtreStatut === s ? "#C4441A" : "#E8DCC8"}`, background: filtreStatut === s ? "#C4441A" : "white", color: filtreStatut === s ? "white" : "#7A5A3A", fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all .2s" }}>
                    {s === "tous" ? "Toutes" : STATUT_RESA[s]?.label}
                    {s === "en_attente" && reservations_attente > 0 && (
                      <span style={{ marginLeft: 6, background: "rgba(255,255,255,0.3)", borderRadius: 10, padding: "1px 6px", fontSize: 11 }}>{reservations_attente}</span>
                    )}
                  </button>
                ))}
              </div>

              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {reservations.filter(r => filtreStatut === "tous" || r.statut === filtreStatut).length === 0
                  ? <Vide texte="Aucune réservation pour le moment" />
                  : (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ background: "#FAF5EC" }}>
                          {["Client", "Service", "Arrivée", "Départ", "Nuits", "Montant", "Paiement", "Statut", "Actions"].map(h => (
                            <th key={h} style={{ padding: "12px 16px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8", whiteSpace: "nowrap" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {reservations.filter(r => filtreStatut === "tous" || r.statut === filtreStatut).map((r, i, arr) => (
                          <tr key={r.id} className="row-hover" style={{ borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none", background: r.statut === "en_attente" ? "rgba(196,132,26,0.03)" : "transparent" }}>
                            <td style={{ padding: "14px 16px" }}>
                              <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.client}</div>
                            </td>
                            <td style={{ padding: "14px 16px", fontSize: 13, color: "#7A5A3A" }}>{r.service}</td>
                            <td style={{ padding: "14px 16px", fontSize: 12, color: "#7A5A3A" }}>{r.dateArrivee}</td>
                            <td style={{ padding: "14px 16px", fontSize: 12, color: "#7A5A3A" }}>{r.dateDepart}</td>
                            <td style={{ padding: "14px 16px", fontSize: 13, color: "#7A5A3A", textAlign: "center" }}>{r.nbNuits}</td>
                            <td style={{ padding: "14px 16px", fontFamily: "'Fraunces',serif", fontSize: 14, fontWeight: 700, color: "#C4441A" }}>{Number(r.montant || 0).toLocaleString()} F</td>
                            <td style={{ padding: "14px 16px" }}>
                              <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20, background: "rgba(196,68,26,0.08)", color: "#C4441A" }}>{r.modePaiement}</span>
                            </td>
                            <td style={{ padding: "14px 16px" }}><BadgeStatut statut={r.statut} map={STATUT_RESA} /></td>
                            <td style={{ padding: "14px 16px" }}>
                              {r.statut === "en_attente" && (
                                <div style={{ display: "flex", gap: 6 }}>
                                  <button className="btn-success" onClick={() => confirmerReservation(r.id)}
                                    style={{ color: "white", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 5, whiteSpace: "nowrap" }}>
                                    <IcCheck /> Confirmer
                                  </button>
                                  <button className="btn-primary" onClick={() => annulerReservation(r.id)}
                                    style={{ color: "white", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 5, whiteSpace: "nowrap" }}>
                                    <IcX /> Annuler
                                  </button>
                                </div>
                              )}
                              {r.statut === "confirmee" && (
                                <span style={{ fontSize: 12, color: "#3D6B2E", fontWeight: 700 }}>✓ Confirmée</span>
                              )}
                              {r.statut === "annulee" && (
                                <span style={{ fontSize: 12, color: "#C4441A", fontWeight: 700 }}>✗ Annulée</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                }
              </div>
            </>
          )}

          {/* ══ PAIEMENTS ══ */}
          {onglet === "paiements" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Paiements</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{paiements.length} transaction{paiements.length !== 1 ? "s" : ""}</p>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 24 }}>
                {[
                  { label: "Total encaissé (séjours)", value: paiements.filter(p => p.statut === "recu").reduce((s, p) => s + (p.montant || 0), 0).toLocaleString(),    suffix: " F", color: "#3D6B2E" },
                  { label: "Commissions SenuTour",     value: paiements.reduce((s, p) => s + (p.commission || 0), 0).toLocaleString(),                                   suffix: " F", color: "#C4441A" },
                  { label: "En attente",               value: paiements.filter(p => p.statut === "en_attente").reduce((s, p) => s + (p.montant || 0), 0).toLocaleString(), suffix: " F", color: "#C4841A" },
                ].map((s, i) => (
                  <div key={i} style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", textAlign: "center" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}<span style={{ fontSize: 13 }}>{s.suffix}</span></div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 4, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {paiements.length === 0 ? <Vide texte="Aucun paiement pour le moment" /> : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#FAF5EC" }}>
                        {["Client", "Service", "Montant séjour", "Commission", "Date", "Statut"].map(h => (
                          <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {paiements.map((p, i) => (
                        <tr key={p.id} className="row-hover" style={{ borderBottom: i < paiements.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                          <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{p.client}</td>
                          <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{p.service}</td>
                          <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 14, fontWeight: 700, color: "#7A5A3A" }}>{Number(p.montant || 0).toLocaleString()} F</td>
                          <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 14, fontWeight: 700, color: "#3D6B2E" }}>{Number(p.commission || 0).toLocaleString()} F</td>
                          <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{p.date}</td>
                          <td style={{ padding: "14px 20px" }}><BadgeStatut statut={p.statut} map={STATUT_PAY} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          )}

          {/* ══ SIGNALEMENTS ══ */}
          {onglet === "signalements" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Signalements</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{signalements.length} signalement{signalements.length !== 1 ? "s" : ""} · {signalements_ouverts} ouvert{signalements_ouverts !== 1 ? "s" : ""}</p>
              </div>

              <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
                {["tous", "ouvert", "en_cours", "resolu"].map(s => (
                  <button key={s} onClick={() => setFiltreStatut(s)}
                    style={{ padding: "7px 16px", borderRadius: 20, border: `1.5px solid ${filtreStatut === s ? "#C4441A" : "#E8DCC8"}`, background: filtreStatut === s ? "#C4441A" : "white", color: filtreStatut === s ? "white" : "#7A5A3A", fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all .2s" }}>
                    {s === "tous" ? "Tous" : STATUT_SIGNAL[s]?.label}
                  </button>
                ))}
              </div>

              {signalements.filter(s => filtreStatut === "tous" || s.statut === filtreStatut).length === 0
                ? <Vide texte="Aucun signalement" />
                : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {signalements.filter(s => filtreStatut === "tous" || s.statut === filtreStatut).map(s => (
                      <div key={s.id} style={{ background: "white", borderRadius: 14, border: `1.5px solid ${s.statut === "ouvert" ? "rgba(196,68,26,0.30)" : "#E8DCC8"}`, padding: "20px 24px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
                              <span style={{ fontSize: 14, fontWeight: 700, color: "#1C1008" }}>{TYPE_SIGNAL[s.type] || s.type}</span>
                              <BadgeStatut statut={s.statut} map={STATUT_SIGNAL} />
                              <span style={{ fontSize: 11, fontWeight: 700, color: PRIORITE[s.priorite]?.color }}>● Priorité {PRIORITE[s.priorite]?.label}</span>
                            </div>
                            <div style={{ fontSize: 13, color: "#7A5A3A", marginBottom: 4 }}>
                              <strong>{s.auteur}</strong> signale <strong>{s.cible}</strong>
                            </div>
                            <div style={{ fontSize: 12, color: "#7A5A3A", marginBottom: 10 }}>{s.date}</div>
                            <div style={{ fontSize: 13, color: "#1C1008", background: "#FAF5EC", borderRadius: 8, padding: "10px 14px", lineHeight: 1.6 }}>{s.desc}</div>
                          </div>
                          {s.statut !== "resolu" && (
                            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                              <button className="btn-success" onClick={() => resoudreSignalement(s.id)}
                                style={{ color: "white", borderRadius: 8, padding: "9px 16px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 6 }}>
                                <IcCheck /> Marquer résolu
                              </button>
                              <button className="btn-primary"
                                onClick={() => toggleSuspension(s.cible_id, false, "utilisateurs")}
                                style={{ color: "white", borderRadius: 8, padding: "9px 16px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 6 }}>
                                <IcBan /> Suspendre
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
}